/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface SegmentSampleOut {
  id: string;
  idx: number;
  start_ms: number;
  end_ms: number;
  text: string | null;
}
